import React from 'react';
import { FadeIn } from './ui/FadeIn';
export function MechanismSection() {
  return <section className="py-32 px-6 relative overflow-hidden" data-id="element-87">
      <div className="absolute inset-0 bg-charcoal-800" data-id="element-88" />
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[600px] h-[600px] bg-amber/10 rounded-full blur-[100px] pointer-events-none" data-id="element-89" />

      <div className="max-w-4xl mx-auto relative z-10 text-center" data-id="element-90">
        <FadeIn data-id="element-91">
          <p className="text-amber uppercase tracking-widest text-sm font-bold mb-4" data-id="element-92">
            La Solución
          </p>
          <h2 className="font-heading text-4xl sm:text-5xl md:text-6xl text-offwhite mb-10" data-id="element-93">
            El Protocolo de Descarga Mental.
          </h2>
        </FadeIn>

        <FadeIn delay={0.2} data-id="element-94">
          <div className="bg-charcoal-700/50 p-8 sm:p-12 rounded-sm border border-amber/20 backdrop-blur-sm text-left" data-id="element-95">
            <p className="text-lg sm:text-xl text-offwhite/90 font-light leading-relaxed mb-6" data-id="element-96">
              Este no es un libro de autoayuda motivacional. Es una{' '}
              <strong className="text-amber font-medium" data-id="element-97">
                intervención biológica de 3 días
              </strong>{' '}
              diseñada para limpiar los receptores de estrés de tu cerebro.
            </p>
            <p className="text-lg sm:text-xl text-offwhite/90 font-light leading-relaxed" data-id="element-98">
              En lugar de luchar contra tus pensamientos, usamos trucos
              neurobiológicos (como el Suspiro Cíclico y el Vaciado de
              Pendientes) para forzar a tu sistema nervioso a entrar en estado
              de seguridad.{' '}
              <strong className="text-offwhite font-medium" data-id="element-99">
                Si cambiás la química de tu sangre, el pánico desaparece solo.
              </strong>
            </p>
          </div>
        </FadeIn>
      </div>
    </section>;
}